import type React from 'react';
import { useState } from 'react';
import { DashboardLayout } from '../components/DashboardLayout.tsx';
import { SourceList } from '../components/SourceList.tsx';
import { AnalyzePanel } from '../components/AnalyzePanel.tsx';
import { IndustryRanking } from '../components/IndustryRanking.tsx';
import type { AuthUser } from '../types/auth.ts';

type Props = {
  user: AuthUser;
  onLogout: () => void;
};

/**
 * メインダッシュボード（admin 専用）。
 * 仕様: knowledge/products/trendscope/specs/ui-layout.md §1
 */
export const DashboardPage = ({ user, onLogout }: Props): React.JSX.Element => {
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = (): void => setRefreshKey((k) => k + 1);

  return (
    <DashboardLayout user={user} onLogout={onLogout}>
      <SourceList onCollected={refresh} />
      <AnalyzePanel onAnalyzed={refresh} />
      <IndustryRanking refreshKey={refreshKey} />
    </DashboardLayout>
  );
};
